export default "__VITE_ASSET__SU_YQdtn__"